import { parseStrokeWidth } from "shared/util/utils";
import { ITraits, Trait } from "../elements-toolbar-types";
import { DropdownButton } from "../toolbar-buttons";
import styles from "./connector-line-style.module.css";
import { Stack, elbowLine, curvedLine, straightLine } from "./toolbar-design-system";
import { ConnectorCurveType } from "./connector-curve-type";
import { LineDash } from "./line-dash";
import { LineWidth } from "./line-width-slider";
import { Sizes } from "frontend/data/shapes/sizes";

type ConnectorStyle = Pick<ITraits, "connectorLineWidth" | "dash" | "lineStyle">;

export default function ConnectorLineStyle({
  values,
  onChange,
}: {
  values: ConnectorStyle[];
  onChange: (trait: Trait, value: any, subMenuData?: any, addUndo?: boolean) => void;
}) {
  const connectorSizes = Sizes.get().connector;
  function renderPopup() {
    const dashes: Record<number, boolean> = {},
      lineStyles: Record<string, boolean> = {};
    for (let i = 0; i < values.length; i++) {
      const dash = values[i].dash ?? 0;
      dashes[dash] = true;
      const lineStyle = values[i].lineStyle ?? "line";
      lineStyles[lineStyle] = true;
    }
    const width = values[0].connectorLineWidth ? parseStrokeWidth(values[0].connectorLineWidth!) : 4;
    return (
      <Stack>
        <LineWidth
          value={width}
          start={connectorSizes.strokeWidth.start}
          step={connectorSizes.strokeWidth.step}
          count={8}
          onChange={(v) => onChange(Trait.connectorLineWidth, v, { connector: { strokeWidth: v } })}
        />
        <ConnectorCurveType
          values={lineStyles}
          onChange={(v) => onChange(Trait.lineStyle, v, { connector: { lineType: v } })}
        />
        <LineDash values={dashes} onChange={(v) => onChange(Trait.dash, v, { connector: { dash: v } })} />
      </Stack>
    );
  }

  if (values.length == 0) {
    return null;
  }
  let icon;
  switch (values[0].lineStyle) {
    case "curve": {
      icon = curvedLine;
      break;
    }
    case "line": {
      icon = straightLine;
      break;
    }
    case "elbow":
    default: {
      icon = elbowLine;
      break;
    }
  }

  // the empty div is because the toolbar adds some padding - makes it look nicer
  return (
    <div>
      <DropdownButton
        className={styles.popupContainer}
        tooltip="Line style"
        renderPopup={renderPopup}
        arrowSize={0}
        margin={8}
      >
        {icon}
      </DropdownButton>
    </div>
  );
}
